import {registerUser, getMobileOtp} from "./apiService"
export const handleUpdateUserDetails = (key ,value, userDetails, setUserDetails) => {
    let details = {...userDetails}
    details[`${key}`] = value
    setUserDetails(details)
}

export const handleSignUp = async (userDetails) => {
    let response = await registerUser(userDetails)
    if (response.status ) {
        return {
            status : response.status,
            data: response.data
        }
    } else {
        return {
            status : response.status,
            code: response.error.code ,
            message: response.error.msg
        }
    }
    
}

export const handleRequestOtp = async (userDetail) => {

        let mobileOtpResponse = await getMobileOtp(userDetail.mobileNumber)
        if (mobileOtpResponse.status) {
            return {
                status: mobileOtpResponse.status,
                userDetails : {...userDetail, newUser: mobileOtpResponse.data.register },
                message:""
            }
        } else {
            return {
                status : false ,
                message : "Invalid Mobile Number"
            }
        }
}   